import { api } from "@/builders/axios";

export const trigger = function (data: { organization_id: number }) {
  return api.post("staffs/trigger/external", data);
};
